import axios, {AxiosError, AxiosRequestHeaders, AxiosResponse} from 'axios';

export const axiosPublic = axios.create({
    baseURL: process.env.REACT_APP_PRODUCTION_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 60000,
});

axiosPublic.interceptors.response.use(
    (response) => {
        if (response) {
            return response;
        }
        return response;
    },
    async (error) => {
        return Promise.reject(error);
    },
);

export const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_PRODUCTION_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 60000,
});

axiosClient.interceptors.request.use(
    async (config) => {
        let tokenStr = localStorage.getItem('access-token');

        config.headers = {
            ...config?.headers,
            Authorization: `Bearer ${tokenStr}`,
        } as AxiosRequestHeaders;
        return config;
    },
    (error) => {
        Promise.reject(error).then();
    },
);
axiosClient.interceptors.response.use(
    (response: AxiosResponse) => {
        return response;
    },
    async (error: AxiosError) => {
        return Promise.reject(error);
    },
);